<template>
    <div>
        <div class="activity-item" v-for="(item, index) in list.slice(0,PreviewNum)" :key="index"
                @click="handleClick(item.id)">
            <div class="cover">
                <img :src="item.imgUrl">
            </div>
            <div class="right">
                <div class="title">
                    {{item.name}}
                </div>
                <div class="date" :title="item.city">
                    <span class="tag">{{item.city}}</span>
                    {{item.startAt}}~{{item.endAt}}
                </div>
                <div class="description" v-html="item.content"></div>
            </div>
        </div>

    </div>
</template>

<script>
    //主題活動用 顯示元件
    export default {
        name: "ActivityItem",
        props: {
            list:{default: ''},
            PreviewNum:{},// 預覽時抓取的筆數
        },
        data() {
            return {
            }
        },
        created() {
        },
        mounted() {

        },
        methods: {
            handleClick(id) {
                this.$router.push({name: 'ActivityHome', query: {"id": id}});
            }
        }
    }
</script>

<style lang="less" scoped>

</style>